import { updateQueryParams } from "@/scripts/common/util";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('.doctor-tabs [role="tab"]').forEach((el) => {
    el.addEventListener("click", () => {
      const url = updateQueryParams([["tab", el.dataset.urlSegment]]);

      window.history.replaceState({}, "", url);
    });
  });
});
